var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeleteFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.478 3H20.5v.002h1.577v1.551H20.5V24h-18V4.553H1v-1.55h1.5V3h4.067l1.936-3h5.992l1.983 3Zm-1.863 0-.956-1.449H9.345L8.413 3h6.202ZM7.873 5.965h-1.55v14.993h1.55V5.965Zm2.936 0h1.551v14.993h-1.55V5.965Zm6.144 0h-1.55v14.993h1.55V5.965Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeleteFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/DeleteFilled.53af20b71b73f4e34dec8ae1e40195ae.svg";